import { ScreenCompanySubscriptions } from '@dms/screen'

export default ScreenCompanySubscriptions
